import { useI18n } from "@/contexts/I18nContext";
import { BRAND_NAME } from "@/lib/brand";

export default function Footer() {
  const { t } = useI18n();
  // `safe-bottom` clears the iOS home indicator so the last row of links
  // isn't sitting under it in the installed PWA (see index.css).
  return (
    <footer data-testid="app-footer" className="mt-24 border-t border-[#E7E0D2] bg-[#FDFBF7] safe-bottom">
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <div className="font-heading text-lg font-semibold text-[#064E3B]" dir="ltr">{BRAND_NAME}</div>
          <p className="text-sm text-[#4B5563] mt-2 max-w-xs">{t("footer.brand_desc")}</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-[#4B5563] font-medium">{t("footer.program_heading")}</div>
          <ul className="mt-3 space-y-2 text-sm text-[#1F2937]">
            <li>{t("footer.program_item_1")}</li>
            <li>{t("footer.program_item_2")}</li>
            <li>{t("footer.program_item_3")}</li>
            <li>{t("footer.program_item_4")}</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-[#4B5563] font-medium">{t("footer.brand_heading")}</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <a data-testid="footer-hikmahverses" href="https://hikmahverses.com" target="_blank" rel="noreferrer"
                 className="text-[#D97706] hover:text-[#B45309]">{t("footer.product_of")}</a>
            </li>
            <li><span className="text-[#4B5563]">© {new Date().getFullYear()} hikmahverses</span></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
